<template>
  <div class="main-wrapper">
    <roe-wizard-header
      title="Participant Data"
      :num="2"
      :save-action="saveChanges"
      v-slot="{ changeRoute }"
    >
      <roe-navigation-header
        :change-route="changeRoute"
        :save-action="saveChanges"
        :start-step-id="10"
        :end-step-id="12"
      ></roe-navigation-header>
    </roe-wizard-header>

    <div class="content">
      <div class="scrollable-content">
        <component
          v-bind:is="currentStep.component"
          :form-data="originalPlan"
        ></component>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import {
  FETCH_COMPLIANCE_LIMITS,
  FETCH_ORIGINAL_PLAN_PROVISION,
  UPDATE_PLAN_PROVISION
} from "@/store/actions.type";
import { mapGetters } from "vuex";
import RoeWizardHeader from "@/components/layouts/WizardHeader";
import RoeNavigationHeader from "@/components/layouts/NavigationHeader";

export default {
  components: {
    RoeNavigationHeader,
    RoeWizardHeader
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(FETCH_ORIGINAL_PLAN_PROVISION, to.params.id);
    return next();
  },
  mounted() {
    this.$store.dispatch(FETCH_COMPLIANCE_LIMITS);
  },
  computed: {
    ...mapGetters(["originalPlan", "currentStep"])
  },
  methods: {
    saveChanges() {
      this.$store.dispatch(UPDATE_PLAN_PROVISION, { plan: this.originalPlan });
    }
  }
};
</script>
